import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT_TOKEN } from '@rx-applications/shared/utils'
import { CookieService } from 'ngx-cookie-service';



@Injectable({
  providedIn: 'root'
})
export class SelectedCurrencyService {
  readonly #currencyStorageKey = 'currency';
  #cookieService = inject(CookieService);  
  #environment = inject(ENVIRONMENT_TOKEN);

  setSelectedCurrency(currencyCode: string): void {
    this.#cookieService.set(this.#currencyStorageKey, currencyCode, {
      expires: 0,
      path: '/',
      secure: this.#environment.production,
    } as any)
  }

  getSelectedCurrency(): string {
    return this.#cookieService.get(this.#currencyStorageKey);
  }
}
